import React from "react";

import type { NodeId } from "~/models/dto";
import type { MetricQuery } from "~/models/metric-query";
import type { Time } from "~/tools/date-time/time";

import { normalizePinnedMetricComponent } from "../../bottom_content/view/panes/east/pinned-items/PinnedItem";
import { PinningButton } from "../../bottom_content/view/panes/east/pinned-items/PinningButton";
import { queryFullComponent } from "../../queries/components";
import { useQuery } from "../../queries/react-query";

export interface PinComponentButtonProps {
	componentIdOrIdentifier: string | number | NodeId;
	timestamp: undefined | Time;
	title: undefined | string;
	unit: undefined | string;
	metricQueries: undefined | ReadonlyArray<MetricQuery>;
}

export const PinComponentButton: React.FC<PinComponentButtonProps> = ({
	componentIdOrIdentifier,
	timestamp,
	title,
	unit,
	metricQueries,
}) => {
	const { data: component, error } = useQuery({
		refetchOnMount: false,
		refetchOnReconnect: false,
		refetchOnWindowFocus: false,
		select: normalizePinnedMetricComponent,

		...queryFullComponent({ componentIdOrIdentifier, timestamp }),
	});

	if (error != null) {
		return null;
	}

	return (
		<PinningButton
			item={
				component == null || metricQueries == null
					? undefined
					: { name: title, unit, metricQueries, component, chartType: "Line" }
			}
		/>
	);
};
